/**
 * 작성자 : 홍선영
 * 날짜 : 2023.10.06
 * 기능 : 모바일 여부 확인 (모바일 + 태블릿)
 */

/**
 * 현재 디바이스가 모바일인지 확인하는 함수
 * 모바일(768px 이하)과 태블릿(768px ~ 1024px) 모두 포함
 * @returns {boolean} 모바일/태블릿 디바이스 여부
 */
export const isMobile = (): boolean => {
  // 1. 터치 지원 여부 확인
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 2. 화면 크기 확인 (모바일 + 태블릿 기준: 1024px 이하)
  const isSmallScreen = window.innerWidth <= 1024;

  // 3. UserAgent 확인 (기본적인 모바일 디바이스 체크)
  const isMobileDevice = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // iPad는 데스크톱 모드일 수 있으므로 제외
  const isIPad = /iPad/i.test(navigator.userAgent);
  const isIPadDesktop = isIPad && !hasTouchScreen;

  return (isMobileDevice && !isIPadDesktop) || (hasTouchScreen && isSmallScreen);
};

/**
 * 현재 디바이스가 iOS인지 확인하는 함수
 * @returns {boolean} iOS 디바이스 여부
 */
export const isIOS = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * 현재 디바이스가 Android인지 확인하는 함수
 * @returns {boolean} Android 디바이스 여부
 */
export const isAndroid = (): boolean => {
  return /Android/.test(navigator.userAgent);
};
